import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { User } from 'src/app/shared/models/security/user';

@Component({
	selector: 'app-add-conversation',
	templateUrl: './add-conversation.component.html',
	styleUrls: ['./add-conversation.component.scss']
})
export class AddConversationComponent implements OnInit, OnChanges {
	searchedName: string = '';

	@Input() usersForNewConversation: User[] = [];
	@Input() conversations: Conversation[] = [];

	user: User = null;

	constructor(protected bsModalRef: BsModalRef) {}

	ngOnInit(): void {
		this.usersForNewConversation = this.usersForNewConversation.filter(
			(user) => {
				return (
					this.conversations.findIndex(
						(convUser) => convUser.user.id === user.id
					) === -1
				);
			}
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.usersForNewConversation || changes.conversations) {
			this.usersForNewConversation =
				changes.usersForNewConversation.currentValue.filter((user) => {
					return changes.conversations.currentValue.find(
						(convUser) => convUser.user.id === user.id
					);
				});
		}
	}

	selectUserForNewConversation(selectedUser: User) {
		this.user = selectedUser;
		this.bsModalRef.hide();
	}
}
